import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { DataAcaoJudicialModel } from '../../../shared/models/data-acao-judicial.model';
import { IrSubJudiTotalModel } from '../../../shared/models/ir-sub-judi-total.model';
import { IrSubJudiModel } from '../../../shared/models/ir-sub-judi.model';
import { PessoaDadosSimplicadosModel } from '../../../shared/models/pessoa-simplificada.model';
import { PessoaService } from '../../../shared/services/pessoa.service';
import { IrFracaoPatrimonialService } from '../service/ir-fracao-patrimonial.service';
import { IrPatrimonialDetalhePdf } from './../../../shared/services/documentos-pdf-imprimir/financeiro/ir-patrimonial/ir-patrimonial-detalhe-pdf';
import { AuthInterceptor } from '../../../interceptor/auth.interceptor';
import { MessageUtil } from '../../../shared/messages/messageUtil';
import { StorafeUtil } from '../../../shared/util/storasge.util';
import { CODIGO_CENTRUS } from '../../../../app.constants';

@Component({
  selector: 'app-ir-fracao-patrimonial-detalhes',
  templateUrl: './ir-fracao-patrimonial-detalhes.component.html',
  styleUrls: ['./ir-fracao-patrimonial-detalhes.component.css']
})
export class IrFracaoPatrimonialDetalhesComponent implements OnInit {

  componentes: any[] = [1];

  param: string;

  @BlockUI() blockUi: NgBlockUI;


  // cdCentrus: 23868;
  // 20087 --- 9170190  --- SILVIO RODRIGUES ALVES
  // cdCentrus = 20087;

  processoFormatadoTela: string;

  pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel = new PessoaDadosSimplicadosModel();

  dataAcaoJudicialModel: DataAcaoJudicialModel = new DataAcaoJudicialModel();

  irSubJudiTotalModel: IrSubJudiTotalModel = new IrSubJudiTotalModel(0, 0, 0);

  irSubJudiModel: Array<IrSubJudiModel> = new Array<IrSubJudiModel>();

  ano: number;
  sindicato: any;
  cdCentrus: number;

  constructor(
    private irFracaoPatrimonialService: IrFracaoPatrimonialService,
    private pessoaService: PessoaService,
    private activatedRoute: ActivatedRoute,
    private authInterceptor: AuthInterceptor,
    private irPatrimonialDetalhePdf: IrPatrimonialDetalhePdf,
    private toastrService: ToastrService,
    private router: Router
  ) { }

  ngOnInit() {
    this.param = '/financeiros/irFracaoPatrimonial/irFacaoPat';

    this.activatedRoute.params.pipe(take(1)).subscribe(arg => this.ano = Number(arg['ano']));

    this._gerenciarCodigoIndentificao();
  }


  getDadosSesseionStorage(): Promise<string> {

    return new Promise((resolve, reject) => {
      const recuperandoObjeto = StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
      resolve(recuperandoObjeto);
    })


  }

  private async _gerenciarCodigoIndentificao(): Promise<void> {
    await this.getDadosSesseionStorage()
      .then(recuperandoObjeto => {

        if (recuperandoObjeto) {
          const novoObjeto = Number(JSON.parse(recuperandoObjeto));
          this.cdCentrus = novoObjeto
        } else {
          this.cdCentrus = this.authInterceptor.getJwtCdCentrus();
        }
        this.getPessoasDadosSimplificado();
      })
  }


  async getPessoasDadosSimplificado() {
    try {
      this.pessoaDadosSimplicadosModel = await this.pessoaService.getPessoas(this.cdCentrus);
      this.getConsultaAcao();
      this.getObterIrSubJudice();
    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }


  async getObterIrSubJudice() {
    try {



      const irSubJudi = await this.irFracaoPatrimonialService.getObterIrSubJudice(this.authInterceptor.getJwtCdCentrus(), this.ano);

      for (const item of irSubJudi) {
        const irSub = new IrSubJudiModel();
        irSub.mmReferencia = item.mmReferencia;
        irSub.vlFracao = item.vlFracao;

        (this.dataAcaoJudicialModel.nrProc3 === '146') ?
          (irSub.vlIrrf = item.vlIrrf - item.vlSindsep, irSub.vlSindsep = item.vlSindsep)
          : (irSub.vlIrrf = 0, irSub.vlSindsep = item.vlIrrf)

        this.irSubJudiModel.push(irSub);
      }

      for (const item of this.irSubJudiModel) {
        this.irSubJudiTotalModel.totalVlFracao += item.vlFracao;
        this.irSubJudiTotalModel.totalVlIrrf += item.vlIrrf;
        this.irSubJudiTotalModel.totalVlSindsep += item.vlSindsep;
      }
    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }

  async getConsultaAcao() {
    this.blockUi.start();

    try {

      const dataAcaoJudicial = await this.irFracaoPatrimonialService.getConsultaAcao(this.authInterceptor.getJwtCdCentrus())

      this.dataAcaoJudicialModel = dataAcaoJudicial;


      (this.dataAcaoJudicialModel.nrProc3 === '154' || this.dataAcaoJudicialModel.nrProc3 === '3413')
        || (this.dataAcaoJudicialModel.nrProc3 === '146') ? this.sindicato = 'SINDSEP' : this.sindicato = 'SINAL';

      this.processoFormatadoTela = `${this.dataAcaoJudicialModel.nrAnoProc}.${this.dataAcaoJudicialModel.nrProc1}
      .0${this.dataAcaoJudicialModel.nrProc2}.000${this.dataAcaoJudicialModel.nrProc3}-${this.dataAcaoJudicialModel.dvProc}
      ${this.dataAcaoJudicialModel.dsVara}de ${this.dataAcaoJudicialModel.dtAcaoJudicial} (${this.sindicato})`
      this.blockUi.stop();
    } catch (error) {
       this.router.navigate([this.param], { skipLocationChange: true })
        this.toastrService.info(MessageUtil.REGISTRO_NAO_ENCONTRADO);
    }
  }


  imprimirPagina() {
    this.irPatrimonialDetalhePdf.funcionarios(this.pessoaDadosSimplicadosModel,
      this.irSubJudiTotalModel, this.irSubJudiModel,
      this._formatarImpressao());
  }

  private _formatarImpressao(): string {
    let processoFomart = ''
    processoFomart = (this.dataAcaoJudicialModel.nrAnoProc + '.' + this.dataAcaoJudicialModel.nrProc1
      + '.0' + this.dataAcaoJudicialModel.nrProc2 + '.000' + this.dataAcaoJudicialModel.nrProc3 + '-' + this.dataAcaoJudicialModel.dvProc + `   ` +
      this.dataAcaoJudicialModel.dsVara.trim() + `  de  ` + this.dataAcaoJudicialModel.dtAcaoJudicial + ' (' + this.sindicato + ')');
    return processoFomart;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/ir-fracao-patrimonial/ir-fracao-patrimonial-detalhes/ir-fracao-patrimonial-detalhes.component.ts